<template>
    <!-- 头部 -->
    <div class="topbar">
        <!-- 移动端汉堡菜单 -->
        <div class="hamburger" v-if="isMobile" @click="toggleDrawer">☰</div>
        <!-- <div class="navlogo" :style="{backgroundImage:'url(' + this.ossPath + 'f/豪华官邸_01.jpg)'}">
        </div> -->
        <div class="navgb">
        <!-- <div class="layui-row fantasy-tips">
        </div> -->
        <!-- 头部区域（可配合layui已有的水平导航） -->
        <ul class="nav">
            <li class="layui-nav-item"><a target="_blank" href="https://tieba.baidu.com/f?kw=%E5%B9%BB%E4%B9%8B%E5%A4%A7%E5%9C%B0">电子公告牌</a></li>
            <li class="layui-nav-item"><a @click="$refs.wangduDialog.open()">城市地图</a></li>
            <li class="layui-nav-item"><a href="#" @click="queryNpc();">NPC定位</a></li>
            <li class="layui-nav-item"><a href="#" @click="queryItem();">货物查询</a></li>
            <li class="layui-nav-item"><a href="#" @click="seekRadar();">寻物雷达</a></li>
            <!-- <li class="layui-nav-item"><a href="">玩家帮派</a></li>
            <li class="layui-nav-item"><a href="">婚姻登记</a></li> -->
            <li class="layui-nav-item"><a @click="showProfile();">个人资料</a></li>
            <!-- <li class="layui-nav-item"><a target="_blank" href="../operation.html">新手指南</a></li> -->
            <!-- 聊天动作内容未做好，暂隐藏（恢复去掉本行注释，2026-10-03） -->
            <!-- <li class="layui-nav-item"><a target="_blank" href="http://blog.huanzhidadi.com/article/chat_movement.html">聊天动作</a></li> -->
            <!-- <li class="layui-nav-item"><a href="">新手指南</a></li>
            <li class="layui-nav-item"><a href="">官方攻略</a></li> -->
        </ul>
        <div class="rollerMessage">
            <p v-if="globalMessage" class="roll-text" :key="globalMessage"
                :style="{animationDuration: rollDuration + 's'}"
                @animationend="onRollEnd" v-html="globalMessage"></p>
        </div>
        <div class="triangle-left-bottom"></div>
        </div>
        
        <!-- NPC定位 -->
        <el-dialog class="wrap" :visible.sync="queryNpcTableVisible" :before-close="query_npc_dialog_close" :modal-append-to-body="false">
            <div class="npcbg">
                <div class="npctitle">
                    NPC定位
                </div>
                <div class="npcSearch">
                    <label>NPC名：</label>
                    <input type="text" v-model="npcName"/>
                </div>
                <div v-if="null != npcList" class="npclist">
                    <el-row>
                    <el-col :span="6"><span>图片</span></el-col>
                    <el-col :span="6"><span>姓名</span></el-col>
                    <el-col :span="6"><span>所在位置</span></el-col>
                    <el-col :span="6"><span>所在城市</span></el-col>
                    </el-row>
                    <div v-for="npc in npcList" v-bind:key="npc.npcId" :id="npc.npcId + '_npc'">
                    <el-row>
                        <el-col :span="6"><img @click="showTitle(npc.npcName)" :title="npc.npcName" :src="ossPath + npc.npcFace"></el-col>
                        <el-col :span="6"><span @click="showTitle(npc.npcDesc)" :title="npc.npcDesc">{{npc.npcName}}</span></el-col>
                        <el-col :span="6"><span @click="showTitle(npc.placeDesc)" :title="npc.placeDesc">{{npc.placename}}</span></el-col>
                        <el-col :span="6"><span>{{npc.cityname}}</span></el-col>
                    </el-row>
                    </div>
                    <div class="pageDiv">
                    <!-- 分页组件 -->
                    <Paging 
                        :name="name"
                        @change="onNpcPageChange"
                        :page-size="size"
                        :total="total"
                        layout="jumper,total"
                        :current-page="curPage"
                    />
                    </div>
                </div>
                <div class="noNpc" v-if="null == npcList">
                    未查询到npc，请修改后重试
                </div>
                <div style="clear:both"></div>
            </div>
        </el-dialog>
        
        <!-- 货物查询 -->
        <el-dialog class="wrap" :visible.sync="queryItemTableVisible" :before-close="query_item_dialog_close" :modal-append-to-body="false">
            <div class="npcbg">
                <div class="npctitle">
                    货物查询
                </div>
                <div class="npcSearch">
                    <label>货物名：</label>
                    <input type="text" v-model="itemName"/>
                </div>
                <div v-if="null != itemList" class="npclist">
                    <el-row>
                    <el-col :span="6"><span>图片</span></el-col>
                    <el-col :span="6"><span>名称</span></el-col>
                    <el-col :span="6"><span>所在商店</span></el-col>
                    <el-col :span="6"><span>所在位置</span></el-col>
                    </el-row>
                    <div v-for="item in itemList" v-bind:key="item.shopItemId" :id="item.shopItemId + '_item'">
                    <el-row>
                        <el-col :span="6"><img @click="showTitle(item.itemName)" :title="item.itemName" :src="ossPath + item.imgSrc"></el-col>
                        <el-col :span="6"><span @click="showTitle(item.itemName)" :title="item.itemName">{{item.itemName}}</span></el-col>
                        <el-col :span="6"><span @click="showTitle(item.shopName)" :title="item.shopName">{{item.shopName}}</span></el-col>
                        <el-col :span="6"><span @click="showTitle(item.placeName)" :title="item.placeName">{{item.placeName}}</span></el-col>
                    </el-row>
                    </div>
                    <div class="pageDiv">
                    <!-- 分页组件 -->
                    <Paging 
                        :name="name"
                        @change="onItemPageChange"
                        :page-size="size"
                        :total="total"
                        layout="jumper,total"
                        :current-page="curPage"
                    />
                    </div>
                </div>
                <div class="noNpc" v-if="null == itemList">
                    未查询到货物，请修改后重试
                </div>
                <div style="clear:both"></div>
            </div>
        </el-dialog>
        
        <!-- 个人资料 -->
        <div v-if="showProfileDiv" class="profile">
          <profile 
            v-on:profile_dialog_close="profile_dialog_close"
            v-bind:profileTableVisible="profileTableVisible"
            v-bind:fantasyUserBO="fantasyUserBO" ></profile>
        </div>
        
        <!-- 寻物雷达 -->
        <div v-if="showRadarDiv" class="radar">
          <radar
            v-on:radar_dialog_close="radar_dialog_close"
            v-bind:radarVisible="radarVisible"
            v-bind:fantasyUserBO="fantasyUserBO"></radar>
        </div>

        <!-- 王都动态地图弹窗（不开新页） -->
        <wangdu-dialog ref="wangduDialog"></wangdu-dialog>
    </div>
</template>

<script>
import {postRequest, postJson} from '../utils/api'
import {getRequest} from '../utils/api'
import Message from 'element-ui/lib/message'
import {mapState} from 'vuex'
import Paging from '../components/Paging';
import profile from '../components/home/profile';
import radar from '../components/home/radar';
import wangduDialog from './maps/wangduDialog.vue';
export default {
  components:{
    Paging,
    profile,
    radar,
    wangduDialog
  },
  data() {
    return {
        isMobile: false,
        npcName: '',
        queryNpcTableVisible: false,
        npcList: [],
        msg: '',
        name:'',
        size:10,
        total:0,
        curPage:1,
        profileTableVisible: false,
        queryItemTableVisible: false,
        itemList: [],
        itemName: '',
        radarVisible: false,
        showRadarDiv: false,
        showProfileDiv: false,
        globalMessage: '',
        rollDuration: 6,
        playing: false,
        news: ['欢迎来到幻之大地！'],
    };
  },
  computed: {
    ...mapState('user', ['fantasyUserBO'])
  },
  watch: {
      npcName: {
        handler(newVal, oldVal) {
          if (newVal != null) {
            this.npcName = newVal;
            this.queryNpc();
          }
        }
      },
      itemName: {
        handler(newVal, oldVal) {
          if (newVal != null) {
            this.itemName = newVal;
            this.queryItem();
          }
        }
      }
  },
    mounted: function () {
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
        document.querySelector('.wrap').addEventListener('touchstart', function () { }, false);
        this.$root.eventHub.$on('rollerMessage', this.rollerMessage);
        this.$root.eventHub.$on('drawerAction', this.onDrawerAction);
        // 初始公告入队播放
        this.tryPlayNext();
    },
  beforeDestroy: function () {
      window.removeEventListener('resize', this.checkMobile);
      this.$root.eventHub.$off('rollerMessage', this.rollerMessage);
      this.$root.eventHub.$off('drawerAction', this.onDrawerAction);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    // 跑马灯队列：一次滚动一条，滚动结束自动播下一条（新公告追加队尾）
    tryPlayNext() {
        if (this.playing || this.news.length === 0) {
            return;
        }
        this.playing = true;
        var temp = this.news.shift();
        this.globalMessage = "　　　　" + temp;
        // 动画时长随文字长度缩放：每字约0.3秒 + 首尾缓冲，保底6秒
        var len = this.globalMessage.replace(/<[^>]+>/g, '').length;
        this.rollDuration = Math.max(6, Math.round(len * 0.3) + 3);
    },
    onRollEnd() {
        this.playing = false;
        this.globalMessage = '';
        this.tryPlayNext();
    },
    // 移动端点击后显示提示信息
    showTitle(value) {
        this.$notify({
            message: value,
            duration: 6000
        })
    },
    rollerMessage(value) {
        this.news.push(value);
        this.tryPlayNext();
    },
    profile_dialog_close(){
        this.showProfileDiv = false;
        this.profileTableVisible = false;
    },
    query_npc_dialog_close() {
        this.queryNpcTableVisible = false;
    },
    onNpcPageChange:function(page){
      this.curPage = page.curPage;
      this.queryNpc();
    },
    query_item_dialog_close() {
        this.queryItemTableVisible = false;
    },
    onItemPageChange:function(page){
      this.curPage = page.curPage;
      this.queryItem();
    },
    queryNpc() {
        this.queryNpcTableVisible = true;
        this.npcList = [];
        var _this = this;
        postRequest('/npc/npc/queryNpc', {
            npcName: this.npcName,
            page: this.curPage
        }).then(resp=> {
            if (resp.status == 200) {
                //成功
                var data = resp.data;
                //console.log(JSON.stringify(data))
                //alert(data.result == false)
                if (data.total > 0) {
                    this.npcList = data.list;
                    this.total = data.total;
                    this.size = data.pageSize;
                    this.curPage = data.pageNum;
                } else {
                    //Message.error("查询道具为空");
                    this.npcList = [];
                    this.total = data.total;
                    this.size = data.pageSize;
                    this.curPage = data.pageNum;
                }
            } else {
            //失败
            Message.error('用户非法⊙﹏⊙∥!');
            }
        }, resp=> {
            Message.error('用户非法⊙﹏⊙∥!');
        });
    },
    queryItem() {
        this.queryItemTableVisible = true;
        this.itemList = [];
        var _this = this;
        postJson('/item/shop/queryShopItem', {
            itemName: this.itemName,
            page: this.curPage
        }).then(resp=> {
            if (resp.status == 200) {
                //成功
                var data = resp.data;
                //console.log(JSON.stringify(data))
                //alert(data.result == false)
                if (data.total > 0) {
                    this.itemList = data.list;
                    this.total = data.total;
                    this.size = data.pageSize;
                    this.curPage = data.pageNum;
                } else {
                    //Message.error("查询道具为空");
                    this.itemList = [];
                    this.total = data.total;
                    this.size = data.pageSize;
                    this.curPage = data.pageNum;
                }
            } else {
            //失败
            Message.error('用户非法⊙﹏⊙∥!');
            }
        }, resp=> {
            Message.error('用户非法⊙﹏⊙∥!');
        });
    },
    //打开个人资料窗口
    showProfile() {
        this.showProfileDiv = true;
        this.profileTableVisible = true;
    },
    seekRadar() {
      // 寻物列表
      this.showRadarDiv = true;
      this.radarVisible = true;
    },
    radar_dialog_close(){
      this.showRadarDiv = false;
      this.radarVisible = false;
    },
    toggleDrawer() {
      this.$root.eventHub.$emit('toggleDrawer');
    },
    onDrawerAction(action) {
      const actions = {
        queryNpc: this.queryNpc,
        queryItem: this.queryItem,
        seekRadar: this.seekRadar,
        showProfile: this.showProfile,
      };
      if (actions[action]) actions[action].call(this);
    },
  }
}
</script>

<style>
    .topbar {
        position: relative;
        height: 100%;
    }
    /* .navlogo {
        float: left;
        width: 265px;
        height: 100%;
        background: url(/f/豪华官邸_01.jpg) no-repeat 0 0;
    } */
    .navgb {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #4c0a51;
        display: flex;
        align-items: center;
        justify-content: space-between;
        overflow: hidden;
    }
    .triangle-left-bottom {
        display: none;
    }
    /* .fantasy-tips {
        width:100%;
        height:30px;
        text-align: right;
        color:#ff0;
    } */
    .rollerMessage {
        position: relative;
        flex: 1;
        min-width: 0;
        height: 29px;
        line-height: 29px;
        font-size: 16px;
        color:bisque;
        overflow: hidden;
    }
    .roll-text {
        position: absolute;
        top: 0;
        left: 0;
        margin: 0;
        padding: 0;
        display: inline-block;
        white-space: nowrap;
        will-change: transform;
        animation-name: roll;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
    }
    @keyframes roll {
        from { transform: translateX(100%); }
        to { transform: translateX(-100%); }
    }
    .nav {
        list-style-type: none;
        margin: 0 0 0 1%;
        padding: 0;
        text-align: center;
        font-size: 14px;
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        /* border: red 1px solid; */
    }
    .nav li {
        width: auto;
        padding: 6px;
    }
    .nav li a {
        color:#fff;
        cursor: pointer;
        display: block;
        text-decoration: none;
    }
    .nav li a:hover {
        text-decoration:underline;
        color:#FF0000
    }

    .wrap {
        margin:auto;
    }
    .npcbg {
        width:100%;
        height: 600px;
    }
   .npcbg .npctitle {
        padding:3px 5px;
        background-color:#72b653;
        font-size:16px;
        font-weight:bold;
        color:#fff;
        letter-spacing:5px;
        text-align:center;
    }
    .npcbg .npclist {
        padding:5px;
        text-align:center;
    }
    /* 家中无道具时，提示语显示的样式 */
    .npcbg .noNpc {
        padding:3px 5px;
        font-size:16px;
        font-weight:bold;
        letter-spacing:5px;
        text-align:center;
        height: 100px;
        line-height: 100px;
    }
    /* 家中道具搜索 */
    .npcSearch {
        height: 26px;
        line-height: 26px;
        font-size: 16px;
        vertical-align:middle;
        text-align: center;
        margin: 5px;
    }
    .npcSearch input {
        height: 26px;
        line-height: 26px;
        vertical-align:middle;
        text-align: center;
    }
    .npclist .el-row {
        font-size: 16px;
    }
    .npclist .el-col {
        box-sizing: border-box;
        overflow: hidden;
    }
    .npclist .el-col span {
        height: 40px;
        line-height: 40px;
        display: inline-block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .npclist .el-col img {
        height: 40px;
        line-height: 40px;
        display: block;
        margin: 0 auto;
        max-width: 100%;
    }
    .pageDiv {
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
    .slide-enter-active, .slide-leave-active {
    transition: all 3s ease-in;
    }
    .slide-leave-to {
    transform: translateX(0px);
    }
    .slide-enter {
    transform: translateX(300px);
    }

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .topbar {
    height: var(--mobile-header-h);
  }

  .hamburger {
    display: block;
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    z-index: 101;
    line-height: 1;
    padding: 4px 8px;
  }

  .navgb {
    height: var(--mobile-header-h);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  /* 隐藏桌面导航和滚动消息 */
  .nav {
    display: none;
  }

  .rollerMessage {
    display: block;
    flex: 1;
    position: relative;
    float: none;
    width: 100%;
    height: var(--mobile-header-h);
    line-height: var(--mobile-header-h);
    text-align: center;
    padding: 0 40px;
    box-sizing: border-box;
  }

  .rollerMessage .roll-text {
    font-size: 12px;
    line-height: var(--mobile-header-h);
  }

  .triangle-left-bottom {
    display: none;
  }

  /* 弹窗置于抽屉之上（抽屉 panel z-index: 500） */
  .el-dialog__wrapper {
    z-index: 600 !important;
  }
  /* 遮罩在弹窗之下，避免覆盖弹窗内容 */
  .v-modal {
    z-index: 595 !important;
  }

  /* 弹窗高度适配 - dialog body 已处理滚动，这里不要限制高度 */
  .npcbg {
    height: auto;
    max-height: none;
    overflow: visible;
  }

  /* NPC/货物列表 - 移动端表格压缩 */
  .npclist {
    padding: 4px;
  }
  .npclist .el-row {
    font-size: 13px;
  }
  .npclist .el-col {
    padding: 0 2px !important;
  }
  .npclist .el-col span {
    height: 36px;
    line-height: 36px;
    font-size: 13px;
  }
  .npclist .el-col img {
    height: 36px;
    width: auto;
    max-width: 100%;
  }
  .npcSearch {
    font-size: 13px;
    height: auto;
    line-height: 1.5;
  }
  .npcSearch input {
    height: 28px;
    font-size: 13px;
  }
  .npcbg .npctitle {
    font-size: 14px;
    letter-spacing: 3px;
    padding: 4px 6px;
  }
}

/* 桌面端隐藏汉堡 */
@media (min-width: 769px) {
  .hamburger {
    display: none;
  }
}
</style>
